import { getUrl, Post, Get, Put, Patch } from '.'

export const ExecSqlGetOnlyIds = async body => {
  return Post(getUrl('cnps.dfs.filtering.execute-sql'), {
    ...body,
    onlyId: true,
  })
}
